var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import { Button, Divider } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { ButtonWrapper, CustomTextField, GridWrapper, Wrapper, } from './CustomAttributeField.Styles';
var columns = [
    {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        editable: true
    },
    {
        field: 'value',
        headerName: 'Value',
        flex: 1,
        editable: true
    },
];
export var CustomAttributeField = function (props) {
    var rows = props.field.value.map(function (value) { return (__assign({ id: value.name }, value)); });
    var _a = useState(''), name = _a[0], setName = _a[1];
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var _d = useState([]), selectedRows = _d[0], setSelectedRows = _d[1];
    var getNameError = function () {
        var _error = '';
        if (rows.find(function (r) { return r.name === name; })) {
            _error = 'Already Exists';
        }
        if (error && value !== '' && !name) {
            _error = 'Required';
        }
        return _error;
    };
    var getValueError = function () {
        var _error = '';
        if (error && name !== '' && !value) {
            _error = 'Required';
        }
        return _error;
    };
    var reSetNameValue = function () {
        setName('');
        setValue('');
    };
    var addAttributes = function () {
        var _rows = __spreadArrays(rows).map(function (val) { return ({
            name: val.name,
            value: val.value
        }); });
        _rows.push({ name: name, value: value });
        props.form.setFieldValue(props.field.name, _rows);
        reSetNameValue();
    };
    var deleteAttributes = function () {
        var _rows = __spreadArrays(rows);
        selectedRows.forEach(function (row_id) {
            var row = _rows.find(function (row) { return row.id === row_id; });
            var index = _rows.indexOf(row);
            _rows.splice(index, 1);
        });
        var formattedRow = _rows.map(function (val) { return ({
            name: val.name,
            value: val.value
        }); });
        props.form.setFieldValue(props.field.name, formattedRow);
        reSetNameValue();
    };
    var onHandleName = function (name) {
        setName(name);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(GridWrapper, null,
            React.createElement(DataGrid, { rows: rows, columns: columns, pageSize: 5, rowsPerPageOptions: [5], checkboxSelection: true, disableSelectionOnClick: true, autoHeight: true, density: 'compact', onSelectionModelChange: function (e) { return setSelectedRows(e); }, onCellEditCommit: function (e) {
                    var _rows = __spreadArrays(rows);
                    var row = _rows.find(function (row) { return row.id === e.id; });
                    var index = _rows.indexOf(row);
                    var newRow = {
                        id: row.id,
                        name: row.name,
                        value: row.value
                    };
                    newRow[e.field] = e.value;
                    if (e.field === 'name') {
                        newRow.id = e.value;
                    }
                    _rows.splice(index, 1, newRow);
                    props.form.setFieldValue(props.field.name, _rows);
                } })),
        React.createElement(ButtonWrapper, null,
            React.createElement(Button, { variant: 'outlined', color: 'primary', disabled: selectedRows.length <= 0, onClick: function () { return deleteAttributes(); } }, "Delete Attribute(s)")),
        React.createElement(Divider, null),
        React.createElement(ButtonWrapper, null,
            React.createElement(CustomTextField, { label: 'Name', placeholder: 'Name', variant: 'outlined', margin: 'dense', fullWidth: true, InputLabelProps: {
                    shrink: true
                }, InputProps: {
                    notched: false
                }, value: name, onChange: function (e) { return onHandleName(e.target.value); }, error: !!rows.find(function (r) { return r.name === name; }) || (error && !name), helperText: getNameError() }),
            React.createElement(CustomTextField, { label: 'Value', placeholder: 'Value', variant: 'outlined', margin: 'dense', fullWidth: true, InputLabelProps: {
                    shrink: true
                }, InputProps: {
                    notched: false
                }, value: value, onChange: function (e) { return setValue(e.target.value); }, error: error && !value, helperText: getValueError() })),
        React.createElement(ButtonWrapper, { className: 'form-buttons' },
            React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () {
                    if (rows.find(function (r) { return r.name === name; }) || !name || !value) {
                        setError(true);
                    }
                    else {
                        setError(false);
                        addAttributes();
                    }
                } }, "Add New Attributes")),
        React.createElement(Divider, null)));
};
CustomAttributeField.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CustomAttributeField.js.map